(function () {
  'use strict';

  var CANVAS_SIZE = 600;

  var GARMENTS = {
    tshirt: {
      label: 'Tee',
      url: 'https://cdn.shopify.com/s/files/1/0618/4070/6654/files/bella-canvas-3001-white_1200x.jpg',
      zone: { top: 0.28, left: 0.32, width: 0.36, height: 0.30 }
    },
    hoodie: {
      label: 'Hoodie',
      url: 'https://cdn.shopify.com/s/files/1/0618/4070/6654/files/comfort-colors-1566-white_1200x.jpg',
      zone: { top: 0.30, left: 0.30, width: 0.38, height: 0.28 }
    },
    tote: {
      label: 'Tote',
      url: 'https://cdn.shopify.com/s/files/1/0618/4070/6654/files/as-colour-1001-natural_1200x.jpg',
      zone: { top: 0.25, left: 0.30, width: 0.40, height: 0.40 }
    }
  };

  var FALLBACK_COLOR = '#F0EEE8';

  var state = {
    canvas: null,
    activeGarment: 'tshirt',
    garmentImages: {},
    designUrl: null,
    whiteInkActive: false,
    garmentFabricObjs: {},
    designObj: null
  };

  function loadGarmentImages() {
    var keys = Object.keys(GARMENTS);
    keys.forEach(function (key) {
      fabric.Image.fromURL(
        GARMENTS[key].url,
        function (img, isError) {
          if (isError || !img) {
            state.garmentImages[key] = null;
          } else {
            state.garmentImages[key] = img;
          }
        },
        { crossOrigin: 'anonymous' }
      );
    });
  }

  function drawFallbackRect(key) {
    var existing = state.garmentFabricObjs[key];
    if (existing) {
      state.canvas.remove(existing);
    }
    var rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: CANVAS_SIZE,
      height: CANVAS_SIZE,
      fill: FALLBACK_COLOR,
      selectable: false,
      evented: false,
      hoverCursor: 'default'
    });
    state.garmentFabricObjs[key] = rect;
    return rect;
  }

  function buildGarmentFabricObj(key, callback) {
    var cachedImg = state.garmentImages[key];
    if (cachedImg === null) {
      var rect = drawFallbackRect(key);
      callback(rect);
      return;
    }
    if (cachedImg) {
      var img = cachedImg;
      img.set({
        left: 0,
        top: 0,
        selectable: false,
        evented: false,
        hoverCursor: 'default'
      });
      var scaleX = CANVAS_SIZE / img.width;
      var scaleY = CANVAS_SIZE / img.height;
      var scale = Math.min(scaleX, scaleY);
      img.set({ scaleX: scale, scaleY: scale });
      img.set({
        left: (CANVAS_SIZE - img.width * scale) / 2,
        top: (CANVAS_SIZE - img.height * scale) / 2
      });
      state.garmentFabricObjs[key] = img;
      callback(img);
      return;
    }
    fabric.Image.fromURL(
      GARMENTS[key].url,
      function (img, isError) {
        if (isError || !img) {
          state.garmentImages[key] = null;
          var rect = drawFallbackRect(key);
          callback(rect);
          return;
        }
        state.garmentImages[key] = img;
        img.set({
          left: 0,
          top: 0,
          selectable: false,
          evented: false,
          hoverCursor: 'default'
        });
        var scaleX = CANVAS_SIZE / img.width;
        var scaleY = CANVAS_SIZE / img.height;
        var scale = Math.min(scaleX, scaleY);
        img.set({ scaleX: scale, scaleY: scale });
        img.set({
          left: (CANVAS_SIZE - img.width * scale) / 2,
          top: (CANVAS_SIZE - img.height * scale) / 2
        });
        state.garmentFabricObjs[key] = img;
        callback(img);
      },
      { crossOrigin: 'anonymous' }
    );
  }

  function composite() {
    var canvas = state.canvas;
    canvas.clear();

    var key = state.activeGarment;
    var zone = GARMENTS[key].zone;

    buildGarmentFabricObj(key, function (garmentObj) {
      canvas.add(garmentObj);

      if (!state.designUrl) {
        canvas.renderAll();
        return;
      }

      fabric.Image.fromURL(
        state.designUrl,
        function (designImg, isError) {
          if (isError || !designImg) {
            canvas.renderAll();
            return;
          }

          var zoneLeft = zone.left * CANVAS_SIZE;
          var zoneTop = zone.top * CANVAS_SIZE;
          var zoneWidth = zone.width * CANVAS_SIZE;
          var zoneHeight = zone.height * CANVAS_SIZE;

          var scaleX = zoneWidth / designImg.width;
          var scaleY = zoneHeight / designImg.height;
          var scale = Math.min(scaleX, scaleY);

          var scaledW = designImg.width * scale;
          var scaledH = designImg.height * scale;

          designImg.set({
            left: zoneLeft + (zoneWidth - scaledW) / 2,
            top: zoneTop + (zoneHeight - scaledH) / 2,
            scaleX: scale,
            scaleY: scale,
            selectable: false,
            evented: false,
            hoverCursor: 'default'
          });

          if (state.whiteInkActive) {
            designImg.set({
              globalCompositeOperation: 'source-over',
              shadow: new fabric.Shadow({
                color: 'rgba(0,0,0,0.18)',
                blur: 8,
                offsetX: 0,
                offsetY: 2
              })
            });
          } else {
            designImg.set({
              globalCompositeOperation: 'multiply',
              shadow: null
            });
          }

          state.designObj = designImg;
          canvas.add(designImg);
          canvas.renderAll();
        },
        { crossOrigin: 'anonymous' }
      );
    });
  }

  function buildToggleButtons() {
    var container = document.getElementById('pb-garment-toggles');
    if (!container) return;
    container.innerHTML = '';

    Object.keys(GARMENTS).forEach(function (key) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pb-mockup__toggle-btn' + (key === state.activeGarment ? ' pb-mockup__toggle-btn--active' : '');
      btn.textContent = GARMENTS[key].label;
      btn.setAttribute('data-garment', key);
      btn.addEventListener('click', function () {
        setActiveGarment(key);
      });
      container.appendChild(btn);
    });
  }

  function setActiveGarment(key) {
    if (!GARMENTS[key]) return;
    state.activeGarment = key;

    var buttons = document.querySelectorAll('.pb-mockup__toggle-btn');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.getAttribute('data-garment') === key) {
        btn.classList.add('pb-mockup__toggle-btn--active');
      } else {
        btn.classList.remove('pb-mockup__toggle-btn--active');
      }
    }

    syncGarmentSelect(key);
    composite();

    document.dispatchEvent(new CustomEvent('proofbox:garment-changed', {
      detail: { type: key, color: 'White' },
      bubbles: true
    }));
  }

  function syncGarmentSelect(key) {
    var select = document.getElementById('pb-garment-type');
    if (!select) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === key) {
        select.selectedIndex = i;
        break;
      }
    }
  }

  function buildColorPicker() {
    var container = document.getElementById('pb-color-picker');
    if (!container) return;
    container.innerHTML = '';

    var swatch = document.createElement('button');
    swatch.type = 'button';
    swatch.className = 'pb-mockup__color-swatch pb-mockup__color-swatch--active';
    swatch.setAttribute('title', 'White');
    swatch.setAttribute('aria-label', 'White');
    swatch.style.backgroundColor = '#FFFFFF';
    swatch.style.border = '2px solid #CCCCCC';
    container.appendChild(swatch);
  }

  function bindWhiteInkToggle() {
    var btn = document.getElementById('pb-white-ink-toggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      state.whiteInkActive = !state.whiteInkActive;
      if (state.whiteInkActive) {
        btn.classList.add('pb-white-ink--active');
      } else {
        btn.classList.remove('pb-white-ink--active');
      }
      composite();
    });
  }

  function bindUploadEvent() {
    document.addEventListener('proofbox:upload-complete', function (e) {
      if (!e.detail || !e.detail.designUrl) return;
      state.designUrl = e.detail.designUrl;
      composite();
    });
  }

  function setupResizeHandler() {
    var canvasWrapper = document.querySelector('#pb-mockup-canvas');
    if (!canvasWrapper) return;

    function resize() {
      var container = canvasWrapper.parentElement;
      if (!container) return;
      var containerWidth = container.offsetWidth;
      if (containerWidth <= 0) return;
      var size = Math.min(containerWidth, CANVAS_SIZE);
      var ratio = size / CANVAS_SIZE;
      state.canvas.setZoom(ratio);
      state.canvas.setWidth(size);
      state.canvas.setHeight(size);
      state.canvas.renderAll();
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        resize();
      });
      var container = canvasWrapper.parentElement;
      if (container) ro.observe(container);
    } else {
      window.addEventListener('resize', resize);
    }

    resize();
  }

  function init() {
    if (!window.fabric) {
      console.error('[ProofBoxMockup] Fabric.js not loaded. Mockup engine cannot initialize.');
      return;
    }

    var canvasEl = document.getElementById('pb-mockup-canvas');
    if (!canvasEl) {
      console.error('[ProofBoxMockup] #pb-mockup-canvas element not found.');
      return;
    }

    state.canvas = new fabric.Canvas('pb-mockup-canvas', {
      width: CANVAS_SIZE,
      height: CANVAS_SIZE,
      selection: false,
      renderOnAddRemove: false
    });

    loadGarmentImages();
    buildToggleButtons();
    buildColorPicker();
    bindWhiteInkToggle();
    bindUploadEvent();
    setupResizeHandler();
    composite();
  }

  function getPreviewDataURL() {
    if (!state.canvas) return null;
    return state.canvas.toDataURL({ format: 'png', multiplier: 1 });
  }

  window.ProofBoxMockup = {
    init: init,
    getPreviewDataURL: getPreviewDataURL
  };
})();
